export default {
  // Endpoints
  loginEndpoint: '/auth/login-token',
  forgotPasswordEndpoint: '/auth/users/get_reset_password_link/',
  resetPasswordEndpoint: '/auth/confirm/reset-password',
  refreshEndpoint: '/auth/token/refresh/',
  logoutEndpoint: '/auth/logout/',
  userDataEndpoint: '/auth/user/me',
  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'access',
  storageRefreshTokenKeyName: 'refresh',
  storageUserDataKeyName: 'userData',
}
